




























































  import Vue from 'vue'
import { Component, Watch } from 'vue-property-decorator'

import serviceModule from '@/store/modules/ServiceModule'
import userModule from '@/store/modules/UserModule'
  import jwt_decode from 'jwt-decode'
  import IToken from '@/models/IToken'
  import { EUserRole } from '@/services/connecteur'
  import UserDelegations from './UserDelegations.vue'

  @Component({
    components: {
      UserDelegations
    }
  })
  export default class UserProfile extends Vue {
    public EUserRole = EUserRole

    public dialog = false

    @Watch('userModule.user')
    public get user () {
      return userModule.user
    }

    public get name() {
      return userModule.user?.fullName
    }

    public get role() {
      const id = userModule.user?.roleModelId as number
      return this.$t(`userRole.${EUserRole[id]}`)
    }

    public get isConnectedAsAnother () {
      return userModule.isConnectedAsAnother
    }

    public get id () {
      return userModule.id
    }

    public get URLLOGIN () {
      return `${process.env.VUE_APP_BACK_URL}/api/Saml/InitiateSingleSignOn?returnUrl=${window.location.href}`
    }

    public get surrogacies () {
      return userModule.surrogacies
    }

    public async logAs(targetUserId?: number) {
      const token = await serviceModule.samlApi.connectAs(targetUserId)
      const decodedToken = jwt_decode(token) as IToken
      const userId = Number.parseInt(decodedToken.user_id, 10)
      const user = await serviceModule.userApi.getById(userId)
      userModule.updateToken(token)
      userModule.updateUser(user)
      localStorage.setItem('token', token)
      this.$router.go(0)
  }
  }
